import React from 'react';

export const IdentityChallengeContext = React.createContext(undefined);
